const AgentiInInvestitoriji = () => {
  return <div>AgentiInInvestitoriji</div>;
};

export default AgentiInInvestitoriji;
